import React, { useState } from "react";
import "./popupack.scss";
import { useNavigate } from "react-router-dom";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { orderstatusAction } from "../../actions/orderAction";
import { useDispatch } from "react-redux";
import Loader from "../loaderComponent/Loader";
import { safeEncode } from "../../common/encoder";
import { useTranslation } from "react-i18next";


const PoppupAck = ({ orderviewList, handleClose, decodeid }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const encodeid = safeEncode(decodeid);
  const parts_listacks = () => {
    navigate("/parts_lists_dispatch", { state: { orderviewList } });
  }
  const { i18n, t } = useTranslation();
  const [remark, setremark] = useState("");

  const onSubmit = async () => {
    let apiReq = {
      order: decodeid,
      status: "dispatched",
      remark: remark
    };
    setIsLoading(true);
    let response = await dispatch(orderstatusAction(apiReq, decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      window.scroll(0, 0);
      navigate(`/parts_lists_dispatch/${encodeid}`, { state: { orderviewList, decodeid } });
      // navigate("/pgmlist");
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  };

  return (
    <div className="popupackconatiners">
      <div className="img-para"><img src={Image_Url.CROSSPOP} onClick={handleClose} /></div>
      <div className="popupackfirst-para">
        <span className="popupackfirst-para-span">{t('parts_list_ack.adddispatchdetails')}</span>
      </div>
      <div className="popupacksecond-para">
        <span className="popuack-second-para">{t('popupack.writeyourmessage')}</span>
      </div>
      <div className="popupackthird-para ">
        <textarea className="text-area-box" name="remark" value={remark} onChange={(e) => setremark(e.target.value)} > </textarea>
      </div>
      <div className="popup-button-container-dispatch">
        <button className="cancel-buttons-pop-dispatch" onClick={handleClose}>{t('popupack.cancel')}</button>
        <button className="acknowledge-buttons-pop-submit" disabled={!remark} onClick={onSubmit} >
          {isLoading ? (
            <Loader className="login-loader" />
          ) : (<>
            {t('parts_list_ack.submit')}</>)}</button>
      </div>

    </div>
  );
};

export default PoppupAck;
